import React, { useEffect } from 'react';
import PageCarousel from '../components/PageCarousel';

function CallForPapers() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const topics = [
    'Deep Learning for Computer Vision', 'Generative AI for Vision', 'Pattern Recognition',
    'Indian Datasets for Computer Vision', 'Segmentation', 'Texture, Shape, Color',
    'Restoration, Enhancement', 'Visual Tracking', 'Motion and Video Analysis',
    'Explainable Vision Systems', 'Compressive Sensing', '3D Reconstruction',
    'Object and Pattern Recognition', 'Machine Learning for Vision and Graphics',
    'Medical Image Analysis', 'Biometrics, Forensics', 'Virtual/Augmented Reality',
    'Human-Computer Interaction', 'Computational Imaging', 'Vision for Robotics and Autonomous Vehicles',
    'Underwater Image Processing', 'Sensors and Modelling', 'Vision-Based Graphics',
    'Activity Recognition', 'Shape from X', 'Vision for Digital Heritage',
    'Shape Analysis', 'Real-Time Graphics', 'Animation and Rendering',
    'Scientific Visualization', 'Document Image Analysis', 'Remote Sensing',
    'Scene Understanding', 'Vision and Language', 'Statistical Methods & Optimization',
    'Vision and Graphics for Society'
  ];

  const importantDates = [
      { event: "Submissions Starts", date: "March 2, 2026" },
      {
        event: "Submission Deadline",
        oldDate: "March 31, 2026",
        newDate: "April 07, 2026",
        newDate1:"April 15, 2026",
        newDate2:"April 30, 2026"
      },
      { event: "Review Results", oldDate: "June 20, 2026", newDate2: "June 23, 2026" },
      { event: "Final Camera Ready Paper Submission", oldDate: "June 20 – July 05, 2026", newDate2: "June 23 – July 08, 2026" },
      { event: "Registration", oldDate: "June 20 – July 05, 2026", newDate2: "June 23 – July 08, 2026" }
    ];

  return (
    <div className="page-container">
      <PageCarousel />

      <section className="section-padding bg-white">
        <div className="container">

          {/* Header */}
          <div className="row mb-2">
            <div className="col-12 text-center">
              <h1 className="section-title" style={{ fontWeight: 700, color: '#111' }}>
                Call For Papers
              </h1>
              <div style={{ width: '80px', height: '4px', background: '#70b60a', margin: '15px auto' }}></div>

              <p className="col-lg-10 mx-auto mt-4 text-muted" style={{ lineHeight: '1.8', textAlign: 'justify' }}>
                We invite papers to be organized as part of NCVPRIPG 2026 at LNMIIT, Jaipur, India.
              </p>
            </div>
          </div>

          {/* Topics */}
          <div className="row mb-5">
            <div className="col-lg-10 mx-auto">
              <div className="topics-list p-4 rounded shadow-sm">
                <div className="row">
                  {topics.map((t, i) => (
                    <div key={i} className="col-md-6 mb-2">
                      <div className="d-flex align-items-start" style={{ borderBottom: '1px solid #e9ecef', paddingBottom: '8px' }}>
                        <i className="lni-chevron-right text-success mr-3" style={{ fontSize: '14px', marginTop: '4px' }}></i>
                        <span style={{ fontSize: '16px', color: '#333' }}>{t}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Paper Prep */}
          <div className="row g-4 mb-5">
            <div className="col-lg-7">
              <div className="card shadow-sm border-0 h-100 p-4">
                <h3 className="fw-bold mb-4 border-start border-4 border-success ps-3">Preparing Your Paper</h3>
                <p className="text-muted mb-4">Download the structured guidelines and official templates for your proceedings paper:</p>
                
                <div className="row g-3">
                  <div className="col-sm-6">
                    <a href="https://www.springer.com/gp/computer-science/lncs/conference-proceedings-guidelines" className="btn btn-outline-success w-100 py-3 d-flex align-items-center justify-content-center">
                      <i className="fas fa-file-pdf me-2"></i> Guidelines PDF
                    </a>
                  </div>
                  <div className="col-sm-6">
                    <a href="https://www.overleaf.com/latex/templates/springer-lecture-notes-in-computer-science/kzwwpvhwnvfj#.WuA4JS5uZpi" target="_blank" rel="noopener noreferrer" className="btn btn-outline-success w-100 py-3 d-flex align-items-center justify-content-center">
                      <i className="fas fa-leaf me-2"></i> Overleaf Template
                    </a>
                  </div>
                  <div className="col-sm-6">
                    <a href="https://ncvpripg25.github.io/ncvpripg25/files/Latexcvip.zip" target="_blank" rel="noopener noreferrer" className="btn btn-outline-dark w-100 py-3 d-flex align-items-center justify-content-center">
                      <i className="fas fa-code me-2"></i> LaTeX Template
                    </a>
                  </div>
                  <div className="col-sm-6">
                    <a href="https://ncvpripg25.github.io/ncvpripg25/files/Microsoftcvip.zip" target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary w-100 py-3 d-flex align-items-center justify-content-center">
                      <i className="fas fa-file-word me-2"></i> Word Template
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-5">
              <div className="card shadow-sm border-0 h-100 p-4 ">
                <h3 className="fw-bold mb-4 border-start border-4 border-success ps-3">Manuscript Submission</h3>
                <p className="opacity-75">Upload your manuscript online at the NCVPRIPG 2026 Microsoft Research portal via the link below:</p>
                <div className="mt-auto py-3">
                   <a href="https://cmt3.research.microsoft.com/NCVPRIPG2026/" target="_blank" rel="noopener noreferrer" className="btn btn-light btn-lg w-100 fw-bold text-center">
                     CMT Submission Link <i className="fas fa-external-link-alt ms-2"></i>
                   </a>
                </div>
                <small className="mt-3 d-block text-center">
                  CMT Acknowledgement: The Microsoft CMT service was used for managing the peer-reviewing process for this conference. This service was provided for free by Microsoft and they bore all expenses, including costs for Azure cloud services as well as for software development and support.
                </small>
              </div>
            </div>
          </div>

          {/* Important Dates */}
          <div className="row mt-5">
            <div className="col-lg-10 mx-auto">
              <h3 className="mb-4" style={{ borderLeft: '5px solid #70b60a', paddingLeft: '15px' }}>
                Important Dates
              </h3>

              <div className="table-responsive shadow">
                <table className="table table-hover mb-0">
                  <thead style={{ background: '#70b60a', color: '#fff' }}>
                    <tr>
                      <th>Event</th>
                      <th>Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    {importantDates.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item.event}</td>
                        <td>
                          {item.oldDate ? (
                            <>
                              {/* Old Date */}
                              <span style={{
                                textDecoration: 'line-through',
                                marginRight: '8px',
                                color: '#777'
                              }}>
                                {item.oldDate}
                              </span>

                              {/* If newDate1 exists → strike newDate also */}
                              {item.newDate2 ? (
                                <>
                                  <span style={{
                                    textDecoration: 'line-through',
                                    marginRight: '8px',
                                    color: '#999'
                                  }}>
                                    {item.newDate}
                                  </span>

                                  <span style={{
                                    textDecoration: 'line-through',
                                    marginRight: '8px',
                                    color: '#999'
                                  }}>
                                    {item.newDate1}
                                  </span>

                                  <strong style={{ color: 'red' }}>
                                    {item.newDate2}
                                  </strong>
                                </>
                              ) : (
                                <strong style={{ color: 'red' }}>
                                  {item.newDate2}
                                </strong>
                              )}
                            </>
                          ) : (
                            item.date
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>

                </table>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default CallForPapers;